import { ItemMappingListPage } from "@/features/item-mapping/pages/ItemMappingListPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/item-mapping/")({
	component: ItemMappingListPage,
});
